/**
 * @generated SignedSource<<3bee1105e5834dc0f1ffd6be07a1179b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type user_isClient$data = {
  readonly isClient: boolean;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentType": "user_isClient";
};
export type user_isClient$key = {
  readonly " $data"?: user_isClient$data;
  readonly " $fragmentSpreads": FragmentRefs<"user_isClient">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "user_isClient"
};

(node as any).hash = "beed99993200063048abc995eda16861";

export default node;
